// Filename: public/amaHelper1.js
import wixData from 'wix-data';
import { session } from 'wix-storage-frontend';
import wixWindow from 'wix-window';
import wixLocation from 'wix-location';
import { saveCleverTapEvent } from 'public/cleverTapEvents.js';

let amaQuestionList = [];
let isFirstTimeFetchingAMAQuestionList = true;
let amaQuestionsListReady = false;
let amaquestionId = '';
var isFetchingForSharedAMA = false;
let lastlyQuestionAsked = '';
var isUsingStaticContent = true;

let url = wixLocation.url;

export function setInitialAMAObserver(data) {
    
    let query = wixLocation.query;
    if (query.diagnostic === "yes") {
        isUsingStaticContent = false;
    }
    if ($w('#ericaBtn').length != 0) {
        startFetchingQuestionProcess()
        // $w('#ericaBtn').disable();
        //console.log('btn is present');
    }
    let amaTitle = wixLocation.path[0];
    if (amaTitle && amaTitle != '0' && wixLocation.prefix == "askerica") {
        sharedAMAItem(amaTitle);
    }
}

function startFetchingQuestionProcess() {
    if (!isUsingStaticContent) {
        wixData.query("askEric")
            .fields("question", "semanticEmbedding", "title")
            .limit(1)
            .eq("hasEmbedding", true)
            .eq("approved", true)
            .find()
            .then((results) => {
                let totalCount = results.totalCount;
                for (let i = 0; i < totalCount; i += 50) {
                    fetchQuestions(i, 0)
                }
            })
    } else {
        amaQuestionsListReady = true;
        //$w('#ericaMSG').text = 'Hey, I’m Erica 👋 I’m ready for you to ask me anything!';
        //$w('#ericaLoader').collapse();
        showErica(false, 'Hey, I’m Erica 👋 I’m ready for you to ask me anything!');
        if(wixLocation.url.indexOf("donate") > -1){
            setTimeout(() => {
                $w('#ericaMessageBox').collapse();
            }, 5000);
        }
        $w('#ericaBtn').enable();
        $w('#ericaMSG').onClick(event => {
            openAMA();
            saveCleverTapEvent('Clicked Erica', {});
        })
        $w('#ericaBtn').onClick(event => {
            openAMA();
            saveCleverTapEvent('Clicked Erica', {});
        })
    }
}

function fetchQuestions(skip = 0, retryCount = 0) {
    if (!isFirstTimeFetchingAMAQuestionList && skip == 0 && retryCount == 0) {
        return;
    } else {
        isFirstTimeFetchingAMAQuestionList = false;
    }
    console.log("Fetching questions:-----", skip, " to ", skip + 50);
    const oneTimelimit = 50;
    wixData.query("askEric")
        .fields("question", "semanticEmbedding", "title")
        .skip(skip)
        .limit(oneTimelimit)
        .eq("hasEmbedding", true)
        .eq("approved", true)
        .eq("archived", false)
        .find()
        .then((results) => {
            if (results.items.length > 0) {
                amaQuestionList = amaQuestionList.concat(results.items);
                if (amaQuestionList.length == results.totalCount) {
                    amaQuestionsListReady = true;
                    //$w('#ericaMSG').text = 'Hey, I’m Erica 👋 I’m ready for you to ask me anything!';
                    //$w('#ericaLoader').collapse();
                    showErica(false, 'Hey, I’m Erica 👋 I’m ready for you to ask me anything!');
                    $w('#ericaBtn').enable();
                    setTimeout(() => {
                        $w('#ericaMessageBox').collapse();
                    }, 5000);
                    $w('#ericaMSG').onClick(event => {
                        openAMA();
                        saveCleverTapEvent('Clicked Erica', {});
                    })
                    $w('#ericaBtn').onClick(event => {
                        console.log("clicked erica")
                        openAMA();
                        saveCleverTapEvent('Clicked Erica', {});
                    })
                    let pendingAMAQuestionToShow = session.getItem("pendingAMAQuestionToShow");
                    if (pendingAMAQuestionToShow && pendingAMAQuestionToShow != "") {
                        console.log('isFetchingForSharedAMA', isFetchingForSharedAMA)
                        if (isFetchingForSharedAMA == false) {
                            session.setItem("pendingAMAQuestionToShow", "");
                            lastlyQuestionAsked = pendingAMAQuestionToShow;
                        } else {
                            isFetchingForSharedAMA = false
                        }
                    }

                    if (lastlyQuestionAsked != '') {
                        openAMA()
                    }

                }
            }
        }).catch(error => {
            console.log("error in fetching AMA questions: ", error);
            if (retryCount < 3) {
                fetchQuestions(skip, retryCount + 1)
            } else {
                console.log("Not Retring--");
            }
        })
}

function showErica(showLoader, message) {
    $w('#ericaMessageBox').expand();
    $w('#ericaMSG').text = message;
    if (showLoader) {
        $w('#ericaLoader').expand();
    } else {
        $w('#ericaLoader').collapse();
    }
}

function hideErica() {
    $w('#ericaMessageBox').collapse();
}

function saveCTAction(eventName, eventData) {
    saveCleverTapEvent(eventName, eventData);
}

export function openAMA() {

    showErica(true, 'Erica is getting ready');
    setTimeout(() => {
        showErica(false, 'Hey, I’m Erica 👋 I’m ready for you to ask me anything!');
    }, 3000);

    const dataToSend = {
        AMAinputData: lastlyQuestionAsked,
        amaQuestionList: amaQuestionList,
        saveCTAction: saveCTAction
    };
    // wixWindow.openLightbox("AMA1");
    wixWindow.openLightbox("AMA1", dataToSend).then(data => {
        // checkClickedOnData(data);
        lastlyQuestionAsked = '';
        showErica(false, 'I’m minimized, but I’m here anytime you need me!');
        setTimeout(() => {
            hideErica()
        }, 5000);
    });
}

function checkClickedOnData(data) {
    if (data && data.clickedOn) {
        if (data.clickedOn == 'feedback') {
            wixWindow.openLightbox('AMA FeedBack', data.dataForFeedback)
                .then(d => {
                    //$w('#AMAinput').value = data.lastQuestionAsked;
                    lastlyQuestionAsked = data.lastQuestionAsked;
                    openAMA();
                    console.log('Got feedback click');
                });
        }
        if (data.clickedOn == 'signup' || data.clickedOn == 'login') {
            session.setItem("pendingAMAQuestionToShow", data.lastQuestionAsked);
            wixWindow.openLightbox('SIGN UP', {
                value: data.clickedOn,
            }).then(d => {
                if (d?.action == 'LinkedIn') {
                    console.log("Signup Popup closed on linkedin navigation")
                } else {
                    session.setItem("pendingAMAQuestionToShow", "");
                    //$w('#AMAinput').value = data.lastQuestionAsked;
                    lastlyQuestionAsked = data.lastQuestionAsked;
                    openAMA();
                    console.log('Google or facebook clicked for login or signup', data.lastQuestionAsked);
                }

            });
        }
        if (data.clickedOn == 'share') {
            wixWindow.openLightbox("Share AMA", data.dataForShare)
                .then(d => {
                    //$w('#AMAinput').value = data.lastQuestionAsked;
                    lastlyQuestionAsked = data.lastQuestionAsked;
                    openAMA();
                });
        }
    }
}

export function sharedAMAItem(amaTitle) {
    isFetchingForSharedAMA = true;
    $w('#preloader').expand();
    wixData.query("askEric")
        .eq("title", parseInt(amaTitle))
        .limit(1)
        .find()
        .then((results) => {
            $w('#preloader').collapse();
            amaquestionId = results.items[0]._id;
            console.log('amaquestionId', amaquestionId);
            const datasharedAMAItem = {
                amaId: amaquestionId
            };

            wixWindow.openLightbox("AMA1", datasharedAMAItem).then(data => {
                checkClickedOnData(data);
            });

        }).catch(error => {
            console.log("error in fetching AMA title: ", error);

        })

}